export const useCurrentSession = () => {
  const { data, status, token, getSession } = useAuth();

  return {
    user: data,
    status,
    token,

    getSession,
  };
};
